import * as React from "react";
const SvgFiRrShoppingBasket = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shopping-basket_svg__a)">
      <path
        fill="#062147"
        d="M23.297 9.034A3 3 0 0 0 21.03 8h-.086C20.445 3.506 16.625 0 12 0S3.555 3.506 3.056 8H3a3 3 0 0 0-2.97 3.425l1.061 7.424C1.511 21.786 4.065 24 7.031 24h9.97c2.965 0 5.52-2.215 5.94-5.151L24 11.425a3 3 0 0 0-.704-2.391M12 2c3.52 0 6.441 2.613 6.928 6H5.072C5.56 4.613 8.48 2 12 2m10.021 9.142-1.06 7.424A4.02 4.02 0 0 1 17 22.001H7.03a4.02 4.02 0 0 1-3.96-3.435l-1.06-7.424a.99.99 0 0 1 .233-.797A.98.98 0 0 1 3 10H21.03c.294 0 .562.122.756.345a.99.99 0 0 1 .235.797M13.001 13v6a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0m5 0v6a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0M8 13v6a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shopping-basket_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShoppingBasket;
